/** 配额授予类型：1 赠送，2 购买 */
export const StorageGrantType = {
  Gift: 1,
  Purchase: 2,
} as const;

export type StorageGrantType = (typeof StorageGrantType)[keyof typeof StorageGrantType];

/** GET /storage/quota/info 的单条配额（quota 单位为字节，expire 为 Unix 秒，0 表示永久/空） */
export type StorageQuotaItem = {
  quota: number;
  expire: number;
  grant_type: StorageGrantType;
};

/** GET /storage/quota/info */
export type StorageQuotaInfo = {
  /** 总配额（字节） */
  count: number;
  /** 已使用（字节） */
  used: number;
  /** 剩余（字节） */
  remain: number;
  /** 已购买的配额明细 */
  items: StorageQuotaItem[];
};

/** 容量包时长：month 月付（30天，无折扣），year 年付（365天，75折） */
export const StorageQuotaPeriod = {
  Month: "month",
  Year: "year",
} as const;

export type StorageQuotaPeriod = (typeof StorageQuotaPeriod)[keyof typeof StorageQuotaPeriod];

/** GET /storage/quota/packages 的单个容量包（amount 单位为分） */
export type StorageQuotaPackage = {
  size_gb: number;
  period: StorageQuotaPeriod;
  days: number;
  amount: number;
  title: string;
};

/** POST /storage/quota/buy 请求 */
export type StorageQuotaBuyRequest = {
  size_gb: number;
  period: StorageQuotaPeriod;
};

/** POST /storage/quota/buy 响应；持 order_id 调统一收银台 POST /orders/pay 完成支付 */
export type StorageQuotaBuyResponse = {
  order_id: string;
  payment_id: string;
  /** 应付金额（分） */
  amount: number;
  /** 支付截止时间（Unix 秒），超时订单自动关闭 */
  pay_deadline?: number;
};

/** 统一存储业务标识 */
export const StorageBusiness = {
  Tplguard: "tplguard",
} as const;

export type StorageBusiness = (typeof StorageBusiness)[keyof typeof StorageBusiness];

export const StorageBusinessLabel: Record<StorageBusiness, string> = {
  [StorageBusiness.Tplguard]: "标记机",
};

export const STORAGE_BUSINESS_FILTER_OPTIONS = [
  { id: "all", label: "全部类型" },
  { id: StorageBusiness.Tplguard, label: StorageBusinessLabel[StorageBusiness.Tplguard] },
] as const;

export function getStorageBusinessLabel(business: string): string {
  if (business in StorageBusinessLabel) {
    return StorageBusinessLabel[business as StorageBusiness];
  }
  return business || "-";
}

export type StorageFileSortBy = "file_size" | "created_at";
export type StorageFileSortOrder = "asc" | "desc";

/** GET /storage/file/list */
export type StorageFileListQuery = {
  page?: number;
  pageSize?: number;
  fileName?: string;
  business?: string;
  sortBy?: StorageFileSortBy;
  sortOrder?: StorageFileSortOrder;
};

/** GET /storage/file/list 的单条文件 */
export type StorageFile = {
  id: number;
  uid: string;
  file_name: string;
  file_size: number;
  file_path: string;
  user_remark: string;
  tag: string;
  business: string;
  remark: string;
  metadata: string;
  expired_at: number;
  is_deleted_file: boolean;
  created_at: number;
  updated_at: number;
};
